module.exports = __webpack_public_path__ + "img/bgAction@2x.17638fac.jpg";